<template>
  <div>
    <h1 class="title-page">
      <v-icon class="material-icons-outlined">import_contacts</v-icon>
      <br />表紙デザインを選択
    </h1>

    <v-card class="card">
      <h2 class="title-bar">表紙デザインを選択</h2>
      <section>
        <v-radio-group v-model="localSelectedDesignType" :hide-details="true">
          <div
            v-for="design in designTypes"
            :key="design.value"
            class="design-option"
          >
            <v-radio :label="design.label" :value="design.value"></v-radio>
            <img
              :src="getImagePath(design.image)"
              :alt="design.label"
              class="design-img"
              @click="openCoverDesignDialogTarget = design.value"
            />
            <CoverDesignDialog
              :dialog-value="openCoverDesignDialogTarget === design.value"
              :design-type="design.value"
              @close-dialog="openCoverDesignDialogTarget = ''"
            />
          </div>
        </v-radio-group>
      </section>

      <v-layout justify-center column pb-4 align-center>
        <v-btn class="v-btn--minwidth" color="primary" @click="handleNext">
          次へ進む
        </v-btn>

        <v-btn class="v-btn--minwidth" color="negative" @click="$emit('back')">
          戻る
        </v-btn>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import CoverDesignDialog from "../Dialogs/CoverDesignDialog.vue";

export default {
  name: "SelectDesignType",
  components: {
    CoverDesignDialog
  },
  props: {
    selectedDesignType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      designTypes: [
        {
          value: "pastel",
          label: "パステル",
          image: "design_type_of_pastel.png"
        },
        {
          value: "simple",
          label: "シンプル",
          image: "design_type_of_simple.png"
        }
      ],
      openCoverDesignDialogTarget: ""
    };
  },
  computed: {
    localSelectedDesignType: {
      get() {
        return this.selectedDesignType;
      },
      set(value) {
        this.$emit("update:selectedDesignType", value);
      }
    }
  },
  created() {
    if (!this.selectedDesignType) {
      this.$emit("update:selectedDesignType");
    }
  },
  methods: {
    getImagePath(filename) {
      return require(`../../../../assets/images/combook_binding/${filename}`);
    },
    handleNext() {
      this.$emit("next");
    }
  }
};
</script>

<style scoped>
.card {
  max-width: 443px;
}
.card section {
  padding: 16px;
}
.design-option {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #0000001f;
}
.design-option:last-child {
  margin-bottom: 0px;
  padding-bottom: 0px;
  border-bottom: none;
}
.design-option >>> .v-label {
  font-weight: bold;
}
.design-img {
  max-width: 100%;
  width: 412px;
  margin-top: 8px;
  display: block;
}
</style>
